import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styled';
import { CustomTooltip } from '../Poppers/CustomTooltip';
import { DomUtils } from '../../utils/dom-utils';

export const Toggle = ({
  value,
  setValue,
  onChange,
  onClick,
  label,
  trailingLabel,
  testId,
  disabled,
  loading,
  className,
  onBlur,
  tooltip
}) => {
  const { elementRef, theme } = DomUtils.useDetectParentTheme();

  return (
    <S.StyledToggle className={className} ref={tooltip ? elementRef : null}>
      {label && <S.StyledLabel data-testid={testId && `label-${testId}`}>{label}</S.StyledLabel>}
      <CustomTooltip title={tooltip} mode={theme}>
        <S.StyledSwitch
          data-testid={testId}
          onChange={e => {
            setValue?.(e.target.checked);
            onChange?.(e);
          }}
          onBlur={onBlur}
          onClick={onClick}
          checked={value}
          disabled={disabled}
        />
      </CustomTooltip>
      {trailingLabel && (
        <S.StyledLabel data-testid={testId && `label-trailing-${testId}`}>{trailingLabel}</S.StyledLabel>
      )}
      {loading && (
        <S.LoadingIcon $leading={!!trailingLabel} size={16} color="var(--button-loading-icon-color)" rotate />
      )}
    </S.StyledToggle>
  );
};

Toggle.propTypes = {
  value: PropTypes.bool,
  setValue: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  label: PropTypes.node,
  trailingLabel: PropTypes.node,
  tooltip: PropTypes.node,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  testId: PropTypes.string,
  className: PropTypes.string,
  onBlur: PropTypes.func
};

export default Toggle;
